import type { ReactNode } from 'react';

interface PermissionDeniedStateProps {
  readonly title?: string;
  readonly description?: string;
  readonly action?: ReactNode;
}

/**
 * Permission-denied state matching shell.css `.state-denied`. Used when
 * the actor sees a section but lacks the permission key for an action,
 * OR when a route guard short-circuits a client-scoped page that the
 * actor cannot see (RLS would 404 the underlying read anyway).
 *
 * Per `docs/13-frontend-integration-rules.md §3` permissions are UX, not
 * security — this state's load-bearing equivalent is the RLS policy.
 */
export function PermissionDeniedState({
  title = 'لا تملك صلاحية فتح هذا القسم',
  description = 'هذه الصفحة تتطلب صلاحية إضافية. تواصل مع مالك الوكالة لطلب الوصول.',
  action,
}: PermissionDeniedStateProps) {
  return (
    <div className="state state-denied">
      <div className="glyph">
        <svg viewBox="0 0 24 24">
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path d="M8 11V7a4 4 0 018 0v4" />
        </svg>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      {action}
    </div>
  );
}
